<template>
    <div class="topbar-container">
        <div class="buy-container">
            <div class="scrollbar-container">
                <div class="line"></div>
                <div class="address-list">
                    <div class="address-list-item" v-if="!isDriving">
                        <div class="item bh bstart" v-if="address" @click="onAddressClick">
                            <div class="bg-contain ico-location"></div>
                            <div class="b1">
                                <div class="bh bstart fz_30">
                                    <div class="name">{{address.contact}}</div>
                                    {{address.telephone}}
                                </div>
                                <div class="address fz_28 breakword">{{address.allAddress}}</div>
                            </div>
                            <div class="bg-contain ico-next"></div>
                        </div>
                        <div class="item bh bc empty" v-if="!address" @click="onAddressClick">
                            <div class="bg-contain ico-add"></div>
                            <div class="fz_30">添加收货地址</div>
                            <div class="bg-contain ico-next"></div>
                        </div>
                    </div>
                    <div class="address-list-item" v-else>
                        <div class="item bh bstart">
                            <div class="bg-contain ico-call"></div>
                            <span class="fz_30">下单电话：{{telephone}}</span>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="buy-list">
                    <div v-if="goodeTitle" class="bh bstart group-title">
                        <div class="bg-contain ico-good"></div>
                        <div class="fz_34">{{goodeTitle}}</div>
                    </div>
                    <div v-for="(item,index) in confirmList" :key="index" class="cart-list-item">
                        <div class="item bh">
                            <div v-if="item.goodsVM.smallPic" class="img bg-100 r6"
                                :style="{backgroundImage: 'url(' + item.goodsVM.smallPic + ')'}"></div>
                            <div class="content b1">
                                <div class="fz_30">{{item.goodsVM.name}}</div>
                                <div class="text fz_30 bh bstart">
                                    <div class="bg-contain ico-maintenance"></div>
                                    <span class="c_red">{{item.goodsVM.price}}</span>
                                    <div class="b1 tr c_red">x{{item.goodsQuantity}}件</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <div class="bh bstart fz_28" v-if="!isDriving">
                            <div class="b1">配送方式：</div>快递免邮
                        </div>
                        <!-- 话费重置没有备注 -->
                        <van-field v-if="orderType!='1'" label="订单备注：" v-model="message" clearable maxlength="50"
                            placeholder="50字以内(选填)"></van-field>
                        <div class="b1 fz_30 bh bend">
                            共{{totalCount}}件&emsp;小计：
                            <span class="c_red">{{totalPrice}}&nbsp;</span> 车主币
                        </div>
                    </div>
                </div>
            </div>
            <div class="buybar bh bstart">
                <div class="b1 fz_28 bh bstart">
                    <div class="text">合计：</div>
                    <span class="c_red fz_40">{{totalPrice}}&nbsp;</span> 车主币
                </div>
                <van-button class="btn btn-goodbuy" @click="onSaveClick">
                    <span class="fz_28">提交订单</span>
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import { saveOrder } from "@/api/cart";
export default {
    mixins: [routeCache, user],
    name: "CartOrderConfirm",
    data() {
        return {
            // 汽车商品：0，话费充值：1，代驾服务：2, 油卡兑换：6
            orderType: "",
            telephone: "",
            fromCart: false,
            message: "",
            confirmList: []
        };
    },
    computed: {
        // 是否虚拟物品
        isDriving() {
            return this.orderType != "0";
        },
        goodeTitle() {
            // console.log(this.orderType)
            const arr = [
                { type: 0, label: "车主用品" },
                { type: 1, label: "话费充值" },
                { type: 2, label: "代驾服务" },
                { type: 6, label: "油卡兑换" }
            ]
            return arr.map(({ type, label }) => {
                if (type == this.orderType) return label
            }).join('')
            // return ["车主用品", "话费充值", "代驾服务"][this.orderType];
        },
        // 总价
        totalPrice() {
            let total = 0;
            this.confirmList.forEach((item) => {
                total += item.goodsQuantity * item.goodsVM.price;
            });
            if (total) {
                total = total.toFixed(2);
            }
            return total;
        },
        // 总数
        totalCount() {
            let total = 0;
            this.confirmList.forEach((item) => {
                total += item.goodsQuantity;
            });
            return total;
        },
        address() {
            // 获取用户默认收货地址
            return this.$store.state.cart.address;
        }
    },
    methods: {
        onAddressClick() {
            this.$router.push({
                name: "UserAddressHome",
                params: { isBuy: true }
            });
        },
        // 获取用户数据后执行
        userLoginend() {
            const me = this,
                params = me.getCache();
            if (!me.$store.state.cart.isSelectAddress) {
                // 获取用户默认收货地址
                me.$store.dispatch("cart/address", true);
            } else {
                me.$store.state.cart.isSelectAddress = false;
            }
            me.confirmList = params.confirmList;
            me.fromCart = params.isCart;
            me.telephone = params.telephone;
            me.orderType = params.orderType;
        },
        onSaveClick() {
            const me = this,
                orderType = me.orderType,
                list = [];
            if (!me.isDriving && !me.address) {
                this.toast.fail("请先添加收货地址");
                return;
            }
            me.confirmList.forEach((item) => {
                list.push({
                    goodsId: item.goodsVM.id,
                    num: item.goodsQuantity
                });
            });
            let telephone, addrId;
            // 汽车商品：0，话费充值：1，代驾服务：2 违章查询 :3 驾照查分 4
            if (orderType != "0") {
                telephone = me.telephone;
            } else {
                addrId = me.address.id;
            }
            saveOrder({
                addrId: addrId,
                fromCart: me.fromCart,
                prepayGoodsList: list,
                message: me.message,
                orderType: orderType,
                telephone: telephone
            }).then((res) => {
                // 刷新购物车
                me.$store.dispatch("cart/cartList", true);
                me.$router.replace({
                    name: "CartOrderPay",
                    params: res.data,
                    query: { orderEndPage: me.$route.query.orderEndPage }
                });
            });
        }
    }
};
</script>
<style scoped lang="scss">
.buy-container {
    background-color: #f1f2f3;
}
.ico-good {
    margin: 0 12px;
}
.info {
    background: #fff;
    padding: 39px 30px 60px 30px;
}
.buybar {
    .text {
        margin-right: 10px;
    }
    .btn {
        width: 220px;
        margin-right: 30px;
    }
}
/deep/ .van-cell {
    padding: 30px 0;
    &:after {
        border: 0;
    }
    .van-cell__title {
        font-size: 28px;
    }
}
</style>
